var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCart = function SvgCart(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#828384",
    d: "M16.768 15.732a2.5 2.5 0 1 1-3.536 3.536 2.5 2.5 0 0 1 3.536-3.536m-7.5 0a2.5 2.5 0 1 1-3.536 3.536 2.5 2.5 0 0 1 3.536-3.536M6.503 3.75A2 2 0 0 1 4.53 2.079l-.067-.408A2 2 0 0 0 2.49 0H1.25C.56 0 0 .56 0 1.25v.132C0 1.999.5 2.5 1.119 2.5c.546 0 1.013.395 1.103.935l1.44 8.644a2 2 0 0 0 1.973 1.671H15.73a2 2 0 0 0 1.874-1.303l2.277-6.119a1.91 1.91 0 0 0-1.792-2.578z"
  })));
};
export default SvgCart;